import type {
  ContentTeamSize,
  LocalizationFrequency,
  NewUserQuizPayload,
  NewUserQuizPriority,
  TargetLanguageCount,
} from '@/shared/api/newUserQuiz';

const QUALIFYING_TEAM_SIZES: readonly ContentTeamSize[] = ['small_team_2_5', 'large_team_5_plus'];
const QUALIFYING_FREQUENCIES: readonly LocalizationFrequency[] = ['regularly_monthly', 'continuously'];
const QUALIFYING_LANGUAGE_COUNTS: readonly TargetLanguageCount[] = ['four_to_ten', 'ten_plus'];
const QUALIFYING_PRIORITIES: readonly NewUserQuizPriority[] = [
  'collaborate_with_team_or_reviewers',
  'integration_into_product_or_workflow',
];

const BLOCKED_BOOKING_TIME_ZONES = new Set([
  'Asia/Calcutta',
  'Asia/Dacca',
  'Asia/Dhaka',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Phnom_Penh',
]);

type NewUserQuizBookingSignals = {
  bookingCountryAllowed?: boolean;
  browserTimeZone?: string;
};

type BrowserTimeZoneResolver = () => string | undefined;

const resolveIntlBrowserTimeZone = (): string | undefined => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const resolveBrowserTimeZone = (
  resolver: BrowserTimeZoneResolver = resolveIntlBrowserTimeZone,
): string | undefined => {
  try {
    return resolver() || undefined;
  } catch {
    return undefined;
  }
};

export const shouldShowNewUserQuizBooking = (
  { content_team_size, localization_frequency, priorities, target_language_count }: NewUserQuizPayload,
  { bookingCountryAllowed, browserTimeZone }: NewUserQuizBookingSignals = {},
): boolean => {
  const answersQualify =
    QUALIFYING_TEAM_SIZES.includes(content_team_size) ||
    QUALIFYING_FREQUENCIES.includes(localization_frequency) ||
    QUALIFYING_LANGUAGE_COUNTS.includes(target_language_count) ||
    priorities.some((priority) => QUALIFYING_PRIORITIES.includes(priority));

  return (
    answersQualify &&
    bookingCountryAllowed !== false &&
    (browserTimeZone === undefined || !BLOCKED_BOOKING_TIME_ZONES.has(browserTimeZone))
  );
};
